import { deepClone } from '@/services/ObjectFormatter'
export default {
    methods: {
        mixDeepClone: deepClone,
        stopAndPrevent: function(e) {
            e.preventDefault()
            e.stopPropagation()
        },
        mixKeepFocusByRef(target, condition = true) {
            if (condition) this.mixFocus(target)
        },
        mixFocusByRef(target) {
            this.$nextTick(() => this.$refs[target].focus())
        },
        // [{val, ref}]
        mixHandleFocus(arr, callback) {
            let verif = true
            arr.forEach(obj => {
                if (verif && !obj.val) {
                    console.log(obj)
                    this.$nextTick(() => this.$refs[obj.ref].focus())
                    verif = false
                }
            })
            if (verif) callback()
        },
    },
}
